import { defineClassNames } from '../../../utils/defineClassNames';

export const classes = defineClassNames('base-modal-layout-footer', {
  root: {
    states: ['showDivider'],
  },
  innerContent: {},
  divider: {},
  actions: {},
  sideActions: {},
});
